export class BeanLogs { 
    constructor(
        public logsIdCdLogs: number,
        public moniIdCdMonitoria: string,
        public logsDsTipo: string,
        public usuaIdCdUsuario: string,        
        public logsDhRegistro: string,
        public logsTxJson   : string,
        public logsTxErro   : string,
        

        
    ){} 
}